<template>
  <div class="login-signup-buttons">
    <CCard
      singleText
      useSingleTextCenter
      content="로그인"
      width="260px"
      height="50px"
      pointer
      fontColor="g700"
      backgroundColor="white"
      @button-click="$emit('login')" />
    <CCard
      singleText
      useSingleTextCenter
      content="회원가입"
      width="260px"
      height="50px"
      pointer
      fontColor="white"
      backgroundColor="p400"
      borderColor="p400"
      @button-click="$emit('signup')" />
  </div>
</template>

<script>
import CCard from "@/components/common/CCard/CCard.vue";

export default {
  name: "LoginSignupButtons",
  components: { CCard },
};
</script>

<style scoped>
.login-signup-buttons {
  display: grid;
  gap: 10px;
  place-items: center;
}
</style>
